import { withOverlayProvider } from './shared/components';
import { type RouteInfo } from './app';

import { routes as routesUnwrapped } from './app';
export const routes = (): RouteInfo[] =>
  routesUnwrapped.map((r) => ({
    ...r,
    Component: withOverlayProvider(r.Component),
  }));

import {
  ClientCredentialsListPage as ClientCredentialsListPageUnwrapped,
  SSOListPage as SSOListPageUnwrapped,
} from './features';
export const SSOListPage = withOverlayProvider(SSOListPageUnwrapped);
export const ClientCredentialsListPage = withOverlayProvider(
  ClientCredentialsListPageUnwrapped
);
